/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type TermType =
  /** プライバシーポリシー */
  | 'PRIVACY_POLICY'
  /** 通信の秘密 */
  | 'SECRECY_OF_COMMUNICATIONS'
  /** 利用規約 */
  | 'TERMS_OF_SERVICE';

export type AppLargeFooterFragment = { terms: Array<{ type: Types.TermType, title: string }> };

export const AppLargeFooterFragmentDoc = gql`
    fragment AppLargeFooter on Query {
  terms {
    type
    title
  }
}
    `;